<div class="wrapper wrapper-dark">
  <div class="title-section mb-5">{{"Cosa offriamo"|translate}}</div>

  <div class="d-inline-b box-list v-top">
    <div class="arrow-green white">
      
      {{"OFFERED_SERVICES_TITLE"|translate}}
    </div>
    <div class="arrow-right"></div>
    <div class="light-box list-service">
      <span *ngFor="let item of getOfferedServices()">{{item}}<br><br></span>
    </div>
  </div>

  <div class="d-inline-b w-65 font-12 v-top margin-top wrapper-service">
    <div class="box-service" *ngFor="let item of getBoxServices()">
      <span *ngFor="let item2 of item;let index=index">
        {{item2}} <i *ngIf="index<item.length-2"></i>
      </span>
    </div>
  </div>
</div>